
import './chip.scss';

enum ChipTypes {
	Primary = 'primary',
	Warning = 'warning',
	Danger = 'danger',
}

interface IChipProps {
	type?: ChipTypes;
	styles?: React.CSSProperties;
}

const Chip: React.FC<IChipProps> = ({
	children,
	type = 'primary',
	styles = {},
}) => {

	return (
		<div className={`chip-container chip-${type}`} style={{ ...styles }}>
			{children}
		</div>
	);
};

export default Chip;
